/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { ContentReferencesStats, ContentReferenceStatus, ContentReferenceUsage, List } from "./data-contracts";

/**
 * No description
 * @tags change-requests-links, links, critical
 * @name ListChangeRequestLinks
 * @summary List all change request links
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/links
 * @secure
 */

// @ts-ignore
export const listChangeRequestLinks: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * Text to display to represent the reference. Possible values include:
     * - `ok` - No problems detected for this content reference.
     * - `broken` - The target does not exist in the revision.
     * - `in-app` - The target is a URL link pointing to an internal location in the app.
     */
    status?: ContentReferenceStatus;
    brokenContext?: "change-request" | "space";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    stats: ContentReferencesStats;
    items: ContentReferenceUsage[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/links",
  method: "get",
  streaming: false,
  tags: ["change-requests-links", "links", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};
